// https://bitbucket.hotterpads.com/projects/RP/repos/trulia/browse/leasing/

import { LeaseStatus } from '@zg-rentals/rental-manager-env';

export const SIGNING_IN_PROGRESS_STATES = new Set([
  LeaseStatus.SENT_FOR_ONLINE_SIGNING,
  LeaseStatus.SENT_FOR_OFFLINE_SIGNING,
  LeaseStatus.SIGNED_BY_TENANT,
  LeaseStatus.COUNTERSIGNING,
]);

export const CREATE_STATES = new Set([LeaseStatus.COMPLETE_DRAFT, LeaseStatus.INCOMPLETE_DRAFT]);

export const DRAFT_STATES = new Set([
  LeaseStatus.COMPLETE_DRAFT,
  LeaseStatus.INCOMPLETE_DRAFT,
  LeaseStatus.SENT_INCOMPLETE_DRAFT,
  LeaseStatus.SENT_COMPLETE_DRAFT,
]);

export const STATES_THAT_SHOW_WHO_HAS_SIGNED = new Set([
  LeaseStatus.SENT_FOR_ONLINE_SIGNING,
  LeaseStatus.SIGNED_BY_TENANT,
  LeaseStatus.COUNTERSIGNING,
]);

export const STATES_THAT_SHOW_LAST_MESSAGE = new Set([
  LeaseStatus.SENT_FOR_ONLINE_SIGNING,
  LeaseStatus.SIGNING_CANCELLED,
]);

// States representing leases that are no longer modifiable, including ones that can't be switched to modifiable states
export const READ_ONLY_STATES = new Set([
  LeaseStatus.ACTIVE,
  LeaseStatus.EXPIRED,
  LeaseStatus.SIGNING_COMPLETE,
  LeaseStatus.TERMINATED,
]);
